import React from 'react';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';

import {
  Link
} from "react-router-dom";

class NavBar extends React.Component{
	constructor(props){
            super(props);
            this.state = {
                backg:"",
                show_bar:"",
                phukien:false,
                trangsuc:false,
                noithat:false,
                giaitri:false,
                dienthoai:false,
                vanphong:false,
                home:true,
                ul_object_home:[
                    {
                        nameHome:"SALE",
                        linkHome:"sale",
                        color:"red"
                    },
                    {
                        nameHome:"THỜI TRANG",
                        linkHome:"Thời trang",
                        onClick:this.showTrangsuc
                    },
                    {
                        nameHome:"PHỤ KIỆN/TIỆN ÍCH",
                        linkHome:"Phụ kiện tiện ích",
                        onClick:this.showPhukien
                    },
                    {
                        nameHome:"TRANG TRÍ/NỘI THẤT",
                        linkHome:"trangtri",
                        onClick:this.showNoithat
                        

                    },
                    {
                        nameHome:"GIẢI TRÍ",
                        linkHome:"giaitri",
                        onClick:this.showGiaitri

                    },
                    {
                        nameHome:"Điện Thoại",
                        linkHome:"dienthoai",
                        onClick:this.showDienthoai
                    },
                    {
                        nameHome:"Văn Phòng Phẩm",
                        linkHome:"vanphong",
                        onClick:this.showVanphong
                    }
                ],
                ul_object_trangsuc:[
                    {
                        name:"THỜI TRANG ",
                        link:"thoitrang",
                        background:"#fff",
                        border:"none",
                        padding:"15px 0px",
                        classI:"fas fa-chevron-left float_left",
                        onClick:this.closeHome
                    },
                    {
                        name:"Quần",
                        link:"/",
                    },
                    {
                        name:"Áo",
                        link:"/",
                    },
                    {
                        name:"Ao khoác",
                        link:"/",
                    }
                ],
                ul_object_phukien_tienich:[
                    {
                        name:"PHỤ KIỆN/ TIỆN ÍCH",
                        link:"phukien",
                        background:"#fff",
                        border:"none",
                        padding:"15px 0px",
                        classI:"fas fa-chevron-left float_left",
                        onClick:this.closeHome
                    },
                    {
                        name:"Túi/Balo/Ví mini",
                        link:"/",
                    },
                    {
                        name:"Phụ kiện",
                        link:"/",
                    },
                    {
                        name:"Tiện ích",
                        link:"/",
                    }
                ],
                ul_object_trangtri_noithat:[
                    {
                        name:"TRANG TRÍ/NỘI THẤT ",
                        link:"phukien",
                        background:"#fff",
                        border:"none",
                        padding:"15px 0px",
                        classI:"fas fa-chevron-left float_left",
                        onClick:this.closeHome
                    },
                    {
                        name:"Trang trí ",
                        link:"/",
                    },
                    {
                        name:"Nội thất",
                        link:"/",
                    },
                    {
                        name:"Gấu bông/Gối bông",
                        link:"/",
                    }
                ],
                ul_object_giaitri:[
                    {
                        name:"GIẢI TRÍ ",
                        link:"phukien",
                        background:"#fff",
                        border:"none",
                        padding:"15px 0px",
                        classI:"fas fa-chevron-left float_left",
                        onClick:this.closeHome
                    },
                    {
                        name:"Game ",
                        link:"/",
                    },
                    {
                        name:"Squishy/Squeeze",
                        link:"/",
                    },
                    {
                        name:"Popping cooking/Candy",
                        link:"/",
                    }
                ],
                ul_object_dienthoai:[
                    {
                        name:"DIEN THOAI",
                        link:"phukien",
                        background:"#fff",
                        border:"none",
                        padding:"15px 0px",
                        classI:"fas fa-chevron-left float_left",
                        onClick:this.closeHome
                    },
                    {
                        name:"Ốp điện thoại ",
                        link:"/",
                    },
                    {
                        name:"Phụ kiện điện thoại",
                        link:"/",
                    }
                ],
                ul_object_vanphong:[
                    {
                        name:"VAN PHONG",
                        link:"phukien",
                        background:"#fff",
                        border:"none",
                        padding:"15px 0px",
                        classI:"fas fa-chevron-left float_left",
                        onClick:this.closeHome
                    },
                    {
                        name:" Đồ dùng học tập",
                        link:"/",
                    },
                    {
                        name:"Sticker",
                        link:"/",
                    },
                    {
                        name:" Quà tặng",
                        link:"/",
                    } 
                ]
        	}
    }
    show_home_destop = (datas) =>{
        var result = null;
            result = datas.map((data, index)=>{
                return ( 
                    <li key={index}> 
                        <Link to={data.linkHome} style={{color:data.color}}>{data.nameHome}</Link>
                    </li>   
                )
            })
        return result
    }

    show_home = (datas) =>{
        var result = null;
            result = datas.map((data, index)=>{
                return ( 
                    <li key={index}> 
                        <Link to={data.linkHome} style={{color:data.color}}>{data.nameHome}</Link>
                        <i  className="fas fa-chevron-right float_right" 
                            onClick={data.onClick}>
                        </i>
                    </li>   
                )
            })
        return result
    }

    show_timeSome = (datas) =>{
        var result = null;
            result = datas.map((data, index)=>{
                return ( 
                    <li key={index}> 
                        <i className={data.classI} onClick={data.onClick}></i>
                        <Link 
                            to={data.link} 
                            style={{border:data.border,padding:data.padding,background:data.background}}>{data.name}
                        </Link>
                    </li>   
                )
            })
        return result
    }


    show_bar=()=>{
    	this.setState({show_bar:"show_bar"})
    }
    close_bar=()=>{
    	this.setState({show_bar:""})
    }

    closeHome=()=>{
    this.setState({
        phukien:false,
        trangsuc:false,
        noithat:false,
        giaitri:false,
        dienthoai:false,
        vanphong:false,
        home:true
    })
}

    showTrangsuc=()=>{
    	this.setState({
    		phukien:false,
            trangsuc:true,
            noithat:false,
            giaitri:false,
            dienthoai:false,
            vanphong:false,
            home:false
    	})
 
    }



    showPhukien=()=>{
    	this.setState({
    		phukien:true,
            trangsuc:false,
            noithat:false,
            giaitri:false,
            dienthoai:false,
            vanphong:false,
            home:false

    	})
    }


    showNoithat=()=>{
        this.setState({
            phukien:false,
            trangsuc:false,
            noithat:true,
            giaitri:false,
            dienthoai:false,
            vanphong:false,
            home:false
        })
    }



    showGiaitri=()=>{
        this.setState({
            phukien:false,
            trangsuc:false,
            noithat:false,
            giaitri:true,
            dienthoai:false,
            vanphong:false,
            home:false
        })
    }

    showDienthoai=()=>{
        this.setState({
            phukien:false,
            trangsuc:false,
            noithat:false,
            giaitri:false,
            dienthoai:true,
            vanphong:false,
            home:false
        })
    }


    showVanphong=()=>{
        this.setState({
            phukien:false,
            trangsuc:false,
            noithat:false,
            giaitri:false,
            dienthoai:false,
            vanphong:true,
            home:false
        })
    }




	render(){
		const {cartId} = this.props;
        const {ul_object_home, ul_object_trangsuc, ul_object_phukien_tienich, ul_object_trangtri_noithat, ul_object_giaitri,ul_object_dienthoai,ul_object_vanphong} = this.state;

        // var style = 0
        //         var scroll1 = window.pageYOffset;
        //         window.onscroll = function(){
        //         var scroll2 = window.pageYOffset;
        //         if (scroll1 > scroll2) {
                    
        //         document.getElementById('nav').style.top = "-120px";

        //         scroll1 = scroll2;
        //         }
        //     }

            


			return (  
			   <div className="menu_bar navbar-fixed-top" id="nav">
					<div className="show_nav" >
						{this.state.show_bar === "" ? <MenuIcon onClick={this.show_bar}/> : <CloseIcon onClick={this.close_bar}/>}
					</div>
					<div className="show_nav_mobie" id={this.state.show_bar}>
						<CloseIcon onClick={this.close_bar}/>
                            <ul>
    							{this.state.home === false ? "" : this.show_home(ul_object_home)}
    							{this.state.trangsuc === false ? "" : this.show_timeSome(ul_object_trangsuc)}
    							{this.state.phukien === false ? "" : this.show_timeSome(ul_object_phukien_tienich)}
                                {this.state.noithat === false ? "" : this.show_timeSome(ul_object_trangtri_noithat)}
                                {this.state.giaitri === false ? "" : this.show_timeSome(ul_object_giaitri)}
                                {this.state.dienthoai === false ? "" : this.show_timeSome(ul_object_dienthoai)}
                                {this.state.vanphong === false ? "" : this.show_timeSome(ul_object_vanphong)}
						     </ul>
                        </div>
					<div className="logo_">
						<Link style={{color:"#000"}} to="">
						    &nbsp; <span id="nav_logo"><img src="https://cdn.glitch.com/1a2d3926-a597-412c-a998-a0aa2ca0b31a%2Fhjlogo.png?v=1595747488539" width="72px" /></span>  
                        </Link>
					</div>
					<div className="nav_">
						<ul>
                            {this.show_home_destop(ul_object_home.slice(0,4))}
						</ul>
					</div>


					<div className="cart_">
						<p><Link to="/search"><i style={{top:"8px", left:"-44px", position:"absolute"}} class="fas fa-search"></i></Link></p>
                        <p><Link to="/cart">Cart <div className="badge">{cartId}</div></Link></p>
					</div>
				</div>
	    	)
	    }
	}
export default NavBar;